var map = {
	"./address_icon.png": 4035,
	"./company-bg.png": 4616,
	"./db-func-item0.png": 3350,
	"./db-func-item1.png": 2367,
	"./db-func-item2.png": 3460,
	"./db_content0.png": 955,
	"./db_content1.png": 9826,
	"./db_title_bg.png": 562,
	"./default_no_image.jpg": 4206,
	"./djxinxilogo.png": 3416,
	"./djxinxilogo1.png": 419,
	"./footer-addess-icon.png": 6187,
	"./footer-email-icon.png": 783,
	"./footer-phone-icon.png": 6691,
	"./footer-postal-icon.png": 9164,
	"./harmful_function.png": 9517,
	"./harmful_title_bg.png": 5633,
	"./main-customer-bg.png": 2987,
	"./main-product-bg0.png": 8346,
	"./main-product-bg1.png": 5923,
	"./main-product-bg2.png": 648,
	"./main-product-bg3.png": 8513,
	"./main-product-bg_gongkuang.jpg": 1624,
	"./main-product-bg_liansuo.jpg": 1714,
	"./main-technical-capability-bg.png": 1827,
	"./manage-func-item0.png": 5499,
	"./manage-func-item1.png": 3954,
	"./manage-func-item2.png": 2137,
	"./manage-func-item3.png": 7936,
	"./manage-func-item4.png": 5967,
	"./manage-func-item5.png": 2166,
	"./news_img0.png": 7380,
	"./news_img1.png": 8509,
	"./news_img10.png": 6665,
	"./news_img11.png": 8544,
	"./news_img2.png": 7302,
	"./news_img3.png": 8847,
	"./news_img4.png": 3472,
	"./news_img5.png": 9721,
	"./news_img6.png": 3138,
	"./news_img7.png": 7291,
	"./news_img8.png": 2252,
	"./news_img9.png": 8165,
	"./news_main_content_0.png": 7715,
	"./news_title_bg.png": 2943,
	"./product_module2.png": 9665,
	"./product_module3.png": 1272,
	"./product_module4.png": 887,
	"./product_module5.png": 5102,
	"./product_module6.png": 1829,
	"./product_title_bg.png": 4871,
	"./solution-item-pic2.png": 3009,
	"./solution-item-pic3.png": 8792,
	"./solution-item-pic4.png": 311,
	"./solution-item-pic5.png": 1998,
	"./solution-item-pic6.png": 9349,
	"./watch_alarm_0.png": 7081,
	"./watch_craft_0.png": 7456,
	"./watch_deal_0.png": 9292,
	"./watch_graph_0.png": 8790,
	"./watch_graph_1.png": 7807,
	"./watch_graph_2.png": 8900,
	"./watch_history_0.png": 690,
	"./watch_title_bg.png": 8819
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;